import { render, staticRenderFns } from "./LetsGetAcquaintedPageTemplate.vue?vue&type=template&id=6ab52321"
import script from "./LetsGetAcquaintedPageTemplate.vue?vue&type=script&lang=js"
export * from "./LetsGetAcquaintedPageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports